"use strict";
exports.__esModule = true;
exports.TableOfContentsWidget = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("../../../utilities/utilities");
var appViewContext_1 = tslib_1.__importDefault(require("../../appViewContext"));
var MessageBlock_1 = tslib_1.__importDefault(require("../../components/MessageBlock"));
var constants_1 = tslib_1.__importDefault(require("./constants"));
var TableOfContents_1 = tslib_1.__importDefault(require("./TableOfContents"));
var utils_1 = require("./utils");
exports.TableOfContentsWidget = function () {
    var wrapperRef = react_1["default"].useContext(appViewContext_1["default"]).wrapperRef;
    var _a = react_1["default"].useState([]), tree = _a[0], setTree = _a[1];
    var _b = react_1["default"].useState(null), expandAll = _b[0], setExpandAll = _b[1];
    var _c = react_1["default"].useState(null), renderEditorDesign = _c[0], setRenderEditorDesign = _c[1];
    react_1["default"].useEffect(function () {
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) || !utilities_1.isBrowser()) {
            setRenderEditorDesign(true);
            return;
        }
        (function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var c, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setRenderEditorDesign(false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, utils_1.generateTableIfContentsTree(wrapperRef.current, constants_1["default"].TREE_INITIALLY_EXPANDED)];
                    case 2:
                        c = _a.sent();
                        setTree(c);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1.message); // tslint:disable-line:no-console
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [wrapperRef]);
    var getExpandAll = function () {
        return expandAll === null ? constants_1["default"].TREE_INITIALLY_EXPANDED : expandAll;
    };
    react_1["default"].useEffect(function () {
        if (expandAll === null) {
            return;
        }
        setTree(function (prev) {
            return utils_1.changeOpenedStateForAll(prev, expandAll);
        });
    }, [expandAll]);
    var handleOpenCloseNode = react_1["default"].useCallback(function (id, opened) {
        setTree(function (prev) {
            return utils_1.changeOpenedStateOfTreeNode(prev, id, opened);
        });
    }, [tree]);
    return (react_1["default"].createElement(react_1["default"].Fragment, null, renderEditorDesign === null ? null : renderEditorDesign ? (react_1["default"].createElement(MessageBlock_1["default"], { color: "primary" }, utilities_1.__('Automaticky generovaný obsah'))) : (react_1["default"].createElement(TableOfContents_1["default"], { expandAll: getExpandAll(), contentTree: tree, onOpenCloseNode: handleOpenCloseNode, onOpenCloseAllNodes: function (open) {
            setExpandAll(open);
        } }))));
};
exports["default"] = react_1["default"].memo(exports.TableOfContentsWidget);
